import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewSelector from './ViewSelector';
import { availableScreens } from '../../../../packages/shared/useScreenNavigation';

/**
 * ScreenNavigation component for universal screen switching
 * 
 * @param {string} currentScreenTitle - Title of the current screen
 * @param {string} size - Size variant ('normal' | 'large')
 */
const ScreenNavigation = ({
  currentScreenTitle = "Screen",
  size = 'large'
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Map shared availableScreens to ViewSelector format
  const screenOptions = availableScreens.map(screen => ({
    value: screen.id,
    label: screen.name,
    icon: screen.icon
  }));

  // Find current screen based on route
  const currentScreen = availableScreens.find(screen => 
    location.pathname === screen.route || location.pathname.startsWith(screen.route)
  );

  const handleScreenChange = (screenValue) => {
    const selectedScreen = availableScreens.find(screen => screen.id === screenValue);
    if (selectedScreen && selectedScreen.route !== location.pathname) {
      navigate(selectedScreen.route);
    }
  };

  return (
    <ViewSelector
      title={currentScreenTitle}
      currentView={currentScreen?.id || 'unknown'}
      onViewChange={handleScreenChange}
      size={size}
      options={screenOptions}
    />
  );
};

export default ScreenNavigation;